module.exports = __webpack_public_path__ + "static/media/Cross bite2.ca4d95bb.png";